import React from 'react'

import ReactNumberFormat, { NumberFormatProps } from 'react-number-format'

import { Input as ChakraInput, InputProps } from '@chakra-ui/input'
import {
  FormControl,
  FormErrorMessage,
  FormLabel,
} from '@chakra-ui/form-control'

import { FieldError } from 'react-hook-form'

import { useTranslation } from 'react-i18next'

type InputBaseProps = InputProps &
  NumberFormatProps & {
    id: string
    label?: string
    error?: FieldError
  }

const NumberInputBase: React.ForwardRefRenderFunction<
  HTMLInputElement,
  InputBaseProps
> = ({ id, label, width, error = null, ...props }, ref) => {
  const { t } = useTranslation()

  return (
    <FormControl isInvalid={!!error} width={width}>
      {!!label && (
        <FormLabel htmlFor={id} fontSize="sm">
          {label}
        </FormLabel>
      )}

      <ChakraInput
        as={ReactNumberFormat}
        id={id}
        name={id}
        size="lg"
        fontSize="sm"
        borderColor="#CBCBCB"
        focusBorderColor="parkoff.orange.300"
        getInputRef={ref}
        {...props}
      />

      {!!error && (
        <FormErrorMessage role="alert">{t(error.message!)}</FormErrorMessage>
      )}
    </FormControl>
  )
}

export const NumberInput = React.forwardRef(NumberInputBase)
